<template>
  <div id="app">
    <Navigation :account-id="accountId" :page-size="pageSize" :template-id="templateId" :include-past="includePast" :only-past="onlyPast"/>
  </div>
</template>

<style lang="scss">
@import "assets/css/style.css";
@import "assets/css/style2.css";
@import "assets/css/animate.min.css";
@import "assets/css/font-awesome.min.css";
@import "assets/css/responsive.css";
</style>


<script>

import Navigation from './components/nav/Navigation'

export default {
  props: {
    accountId: {
      type: String
    },
    pageSize: {
      type: Number
    },
    templateId: {
      type: Number
    },
    includePast: {
      type: Boolean
    },
    onlyPast: {
      type: Boolean
    },
  },
  components: {
    Navigation
  }
}

</script>
